module.exports = __webpack_public_path__ + "img/tm.7f458b4c.svg";